"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SupportedLanguage } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { situationsKeys } from "@/features/situations";
import { thoughtKeys, useThoughtRefresh } from "@/features/thoughts";
import { parseResume } from "../api/parseResume";

interface ParseResumeInput {
  preferredLanguage: SupportedLanguage;
  selectedFile: File;
}

export default function useParseResumeMutation() {
  const { accessToken } = useAuth();
  const queryClient = useQueryClient();
  const { refreshStudioThoughts, refreshSuggestedThoughts } =
    useThoughtRefresh();

  return useMutation({
    mutationFn: ({ preferredLanguage, selectedFile }: ParseResumeInput) =>
      parseResume(accessToken, preferredLanguage, selectedFile),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: situationsKeys.all,
        }),
        queryClient.invalidateQueries({
          queryKey: thoughtKeys.all,
        }),
      ]);
      refreshStudioThoughts();
      refreshSuggestedThoughts();
    },
  });
}
